// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1riTD","header":"ClearentDisclaimer_header__3blRB","inner":"ClearentDisclaimer_inner__1kStC"};